<template>
  <v-row class="mx-0 my-0" />
</template>

<script>
export default {
  name: 'CasaoneFilter',
  emits: ['isFilterSelected'],
  created() {
    this.$emit('isFilterSelected', true)
  },
}
</script>
